import * as React from 'react';

// API
import apibridge from '../../apibridge';

// REDUX
import { useAppDispatch } from '../../store';
import UserSlice from '../../store/slices/User';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { useHistory } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { closeModalType } from '../../components/GlobalModal';

interface CancelPlanModalTypes {
	closeModal?: closeModalType;
}

const CancelPlanModal: React.FC<CancelPlanModalTypes> = ({ closeModal }) => {
	const history = useHistory();
	const dispatch = useAppDispatch();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const cancelPlan = async () => {
		setIsLoading(true);

		const response = await apibridge.cancelPlan();

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			dispatch(UserSlice.actions.forceUpdate({}));

			history.push('/');
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to <strong>cancel</strong> your plan?
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={cancelPlan}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default CancelPlanModal;
